import BaseModel from './BaseModel';
import moment from 'moment';
import type { Moment } from 'moment';

/** Signal contact known by the Yoda Signal account. */
class SignalContact extends BaseModel {
    _id: string;
    name: string | null;
    userId?: string | null;
    defaultProject?: string | null;
    raw: AnyObj;
    identityStatus?: string | null;
    identityMessage?: string | null;
    identityResolvedBy?: string | null;
    createdAt?: Moment;
    updatedAt?: Moment;

    constructor(properties: AnyObj) {
        super({});

        this._id = properties._id;
        this.name = properties.name ?? null;
        this.userId = properties.userId ?? null;
        this.defaultProject = properties.defaultProject ?? null;
        this.raw = properties.raw || {};
        this.identityStatus = properties.identityStatus ?? null;
        this.identityMessage = properties.identityMessage ?? null;
        this.identityResolvedBy = properties.identityResolvedBy ?? null;

        if ('createdAt' in properties)
            this.createdAt = moment(properties.createdAt);
        if ('updatedAt' in properties)
            this.updatedAt = moment(properties.updatedAt);
    }
}

export default SignalContact;
